const fetchData = (pageId: number): string => `
    {
    page(id: "${pageId}", idType: DATABASE_ID) {
      PostLoginPage {
        titleWelcome
        descriptionWelcome
      }
    }
  }
`;
export default fetchData;
